import React from 'react';
import { Dialog, Button } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';
import { OnBehalfDisclaimerDialogProps } from './OnBehalfDisclaimerDialog.props';

export const OnBehalfDisclaimerDialog: React.FC<
  OnBehalfDisclaimerDialogProps
> = ({ isOpen, onClose, onConfirm, onReturn }) => {
  const { t } = useTranslate();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleReturn = () => {
    onReturn();
    onClose();
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>
            {t('form.employeeDetails.raiseOnBehalf.disclaimerDialog.title')}
          </Dialog.Title>
        </Dialog.Header>
        <Dialog.Description>
          {t('form.employeeDetails.raiseOnBehalf.disclaimerDialog.description')}
        </Dialog.Description>

        <Dialog.Footer>
          <Button variant="secondary" border="default" onClick={handleConfirm}>
            {t(
              'form.employeeDetails.raiseOnBehalf.disclaimerDialog.footer.agree'
            )}
          </Button>
          <Button variant="primary" border="none" onClick={handleReturn}>
            {t(
              'form.employeeDetails.raiseOnBehalf.disclaimerDialog.footer.return'
            )}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
